<template>
  <td v-bind="$attrs" :class="{ 'table_cell--compact': compact }">
    <slot></slot>
  </td>
</template>

<script>
export default {
  name: "TableCell",
  props: {
    /**
     * @vuese
     * This flag adjusts the styling to use in conjunction with the CompactTable component
     */
    compact: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~include-media";

td {
  margin: 0;
  border: 0;
  font: inherit;
  vertical-align: middle;
  padding: 10px 24px 12px;
  word-wrap: anywhere;
  overflow-wrap: anywhere;

  @include media("<tablet") {
    padding: 10px 16px;
  }

  &.table_cell--compact {
    padding: 4px 8px;
  }

  &:first-child {
    padding-left: 24px;
  }

  &:last-child {
    padding-right: 24px;
  }
}
</style>
